import Test from "../Pages/Test_Step"

// Load Models
const LoadModel = async (Passed) => {
    let result = await Test.LoadSchema(Passed)

    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        let result = await LoadModel(Parameters)
        return result;
    },
}